<script>
export default {
    name: 'vue-button',

    props: {
        type: {
            type: String,
            default: 'white'
        },

        title: String,

        active: {
            type: Boolean,
            default: false
        },

        buttonType: {
            type: String,
            default: 'button'
        },

        size: {
            type: String,
            default: null
        },

        loading: {
            type: Boolean,
            default: false
        },

        loadingText: {
            type: String,
            default: 'Loading'
        },

        showLoadingSpinner: {
            type: Boolean,
            default: true
        },

        showLoadingText: {
            type: Boolean,
            default: true
        },

        disabled: {
            type: Boolean,
            default: false
        },

        showRedDot: {
            type: Boolean,
            default: false
        },

        icon: {
            type: String,
            default: null
        },

        iconPosition: {
            type: String,
            default: 'left'
        },

        responsive: {
            type: Boolean,
            default: false
        },

        bordered: {
            type: Boolean,
            default: undefined
        },

        badgeCount: {
            type: [String, Number],
            default: null
        },

        disabledStyleOnly: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        classObject() {
            return {
                disabled: this.loading || this.disabled,
                btn: true,
                relative: this.showRedDot || this.badgeCount,
                'btn-white': this.type === 'white',
                'btn-inverse': this.type === 'inverse',
                'btn-primary': this.type === 'primary',
                'btn-danger': this.type === 'danger',
                'btn-warning': this.type === 'warning',
                'btn-info': this.type === 'info',
                'btn-success': this.type === 'success',
                'btn-link': this.type === 'link',
                'btn-xs': this.size === 'xs',
                'btn-sm': this.size === 'sm',
                'btn-lg': this.size === 'lg',
                'active': this.active,
                'btn-bordered': this.bordered === true,
                'no-border': this.bordered === false
            }
        },

        isDisabled() {
            return (this.loading || this.disabled);
        },

        iconPadding() {
            let margin = '';

            if (this.iconPosition === 'left' && this.icon !== null) {
                margin = 'm-r-5';
            }

            if (this.iconPosition === 'right' && this.icon !== null) {
                margin = 'm-l-5';
            }

            return this.$slots.default ? margin: '';
        },
    },

    methods: {
        click(event) {
            this.$emit('click', event);
        }
    }
}
</script>

<template>
    <button
        :type="buttonType"
        :title="title"
        :class="classObject"
        autocomplete="off"
        :disabled="isDisabled && !disabledStyleOnly"
        @click="click"
    >
        <template v-if="!loading">
            <i v-if="icon !== null && iconPosition === 'left'" :class="[icon, iconPadding]"></i>
            <span :class="{desktop: this.responsive}">
                <slot ref="textSlot"></slot>
            </span>
            <i v-if="icon !== null && iconPosition === 'right'" :class="[icon, iconPadding]"></i>
        </template>
        <span v-else>
            <slot name="spinner" v-if="showLoadingSpinner">
                <i class="el-icon-loading" :class="{'m-r-5': showLoadingText}"></i>
            </slot>

            <template v-if="showLoadingText">
                {{ loadingText }}
            </template>
        </span>
        <span v-if="badgeCount" class="badge-count fade in">{{ badgeCount }}</span>
        <span v-if="showRedDot" class="red-dot js-dt-red-dot fade in"></span>
    </button>
</template>